import {createContext, useContext} from 'react';
import type {Editor} from 'grapesjs';

export const GrapesjsEditorContext = createContext<Editor | undefined>(undefined);
export const IsMobileScreenContext = createContext<boolean>(false);

export const useGrapesjsEditor = (): Editor => {
  const context = useContext(GrapesjsEditorContext);
  if (!context) {
    throw new Error('useGrapesjsEditor must be used within a GrapesjsEditorProvider');
  }

  return context;
};

export const useIsMobileScreen = (): boolean => {
  return useContext(IsMobileScreenContext);
};
